import { render, staticRenderFns } from "./Cookie.vue?vue&type=template&id=3edac5a6&scoped=true&"
import script from "./Cookie.vue?vue&type=script&lang=ts&"
export * from "./Cookie.vue?vue&type=script&lang=ts&"
import style0 from "./Cookie.vue?vue&type=style&index=0&id=3edac5a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edac5a6",
  null
  
)

export default component.exports